import { TriStateRange } from '~/_shared/constants/triStateRange.enum';
import { notNullsy } from '~/_shared/utils/typeGuards';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import type {
  BoundaryFilter, BoundaryFiltersState,
} from '~/store/mapSettings/toolsState/boundary/mapSettingsToolsStateBoundary.state';

const emptyBoundaryFilter = {
  filteredBoundaries: [],
  filteredBoundaryTerritories: [],
  showAll: TriStateRange.Full,
} as const satisfies BoundaryFilter;

export const boundaryFiltersStateToBoundaryFilters = (
  baseFilters: BoundaryFiltersState,
  boundaryTerritoryGroups: ReadonlyArray<BoundaryTerritoryGroup>,
) => ({
  get: (boundaryGroupId: BoundaryGroupId) => {
    return baseFilters[boundaryGroupId] ?? emptyBoundaryFilter;
  },
  entries: boundaryTerritoryGroups
    .map((boundaryTerritoryGroup) => {
      const boundaryGroupId = boundaryTerritoryGroup.boundaryGroupId;
      const filter = baseFilters[boundaryGroupId];
      return filter ? {
        boundaryGroupId,
        filter,
      } : null;
    })
    .filter(notNullsy),
});
